import { useRosterState } from 'amazon-chime-sdk-component-library-react';
import { Roles } from 'constants/role';

export const useStudentList = () => {
  const { roster } = useRosterState();
  const attendees = Object.values(roster).filter(item => item.externalUserId.split('$').includes(Roles.ONECLASS_STUDENT));
  attendees.forEach(item => item.name = item.externalUserId.split('$')[0]);
  return attendees
};
